<template>
	<v-layout row align-center style="z-index:3;">
<v-expansion-panel class="phoneTopMenu" v-model="phoneSearchOpen">
	<v-expansion-panel-content expand-icon="">

		<template v-slot:header>
			<v-layout align-center row fill-height justify-space-between>			
				<v-flex xs1>
					<img src="../images/ua_block_rgb_3.3c82a4c.png" class="blockaPhone">
				</v-flex>
				<v-flex class="topTitlePhone text-xs-center pl-4">
					<div
						:style="darkTheme ? 'color: whitesmoke;' : 'color: black;'"> 
							Interactive Floorplans 
					</div>
				</v-flex>
				<v-flex xs1 class="text-xs-right"><v-icon medium >{{phoneSearchOpen ? 'expand_less' : 'search'}}</v-icon></v-flex>
			</v-layout>
		</template>
		<v-card class="px-3" height="80">
			<v-divider></v-divider>
			<v-layout class="pt-2" column >
				<v-flex xs8>
					<v-autocomplete
						ref="autocomplete"
						v-model="selectedBuilding"
						v-on:click="selectedBuilding = null"
						@keyup.enter="directEnter"
						@change="closeKeyboard"
						hide-no-data
						auto-select-first
						autocomplete
						solo
						flat
						style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
						:items="buildingItems"
						:filter="customFilter"
						label="Building Name / Number / Addr"
						single-line
						:menu-props="{ maxHeight: 200 }"
						>
						<template
							slot="selection"
							slot-scope="{ item, tile }"
						  >
							<v-layout v-if="selectedBuilding" v-on:click="selectedBuilding = null">
							<v-list-tile-avatar dark tile color="grey darken-3" style="color: white;">
								{{item.bldgAlpha}}
							</v-list-tile-avatar>
							<v-list-tile-content>
							  <v-list-tile-title>
								{{item.name}}
							  </v-list-tile-title>
							  <v-list-tile-sub-title v-text="item.address"></v-list-tile-sub-title>
							</v-list-tile-content>
							</v-layout>
						  </template>
						<template
							slot="item"
							slot-scope="{ item, tile }"
						  >
							<v-list-tile-avatar dark tile color="grey darken-3" style="color: white;">
								{{item.bldgAlpha}}
							</v-list-tile-avatar>
							<v-list-tile-content>
							  <v-list-tile-title>
								{{item.name}}
							  </v-list-tile-title>
							  <v-list-tile-sub-title v-text="item.address"></v-list-tile-sub-title>
							</v-list-tile-content>
						  </template>
					</v-autocomplete>
				</v-flex>
				
				<v-flex xs1 style="position: relative; top: -20px;"> 
					<v-autocomplete
						ref="roomselect"
						type="number"
						v-model="selectedRoom"
						@change="roomSelectEvent"
						autocomplete
						auto-select-first
						solo
						flat
						:items="roomItems"
						label="Room"
						single-line
					></v-autocomplete>
				</v-flex>
			
			</v-layout>
		</v-card>
		<v-flex class="text-xs-center">
			<v-btn icon class="collapseButton" style="color: darkgrey">
				<v-icon @click="updatePhoneSearch(null)"
				large class="collapseIcon">expand_less</v-icon>
			</v-btn>
		</v-flex>
	</v-expansion-panel-content>
</v-expansion-panel>
</v-layout>
<!--   
	<v-toolbar :height="toolbarHeight" app fixed>

		<v-layout class="pr-2" column justify-start>				
					<v-layout align-center row fill-height justify-space-between>			
						<v-flex xs1>
							<img src="../images/ua_block_rgb_3.3c82a4c.png" class="blockaPhone">
						</v-flex>
						<v-flex class="topTitlePhone text-xs-center pl-4">
							<a href="/" 
								style="text-decoration: none;"" 
								:style="darkTheme ? 'color: whitesmoke;' : 'color: black;'"> 
									Interactive Floorplans 
							</a>
						</v-flex>
						<v-flex xs1 class="text-xs-right"><v-icon medium @click="toggleToolbar">{{toolbarHeight > 70 ? 'expand_less' : 'search'}}</v-icon></v-flex>
					</v-layout>
				
				<v-spacer></v-spacer><v-spacer></v-spacer><v-spacer></v-spacer>
			
		<v-layout v-if="toolbarHeight > 70" class="pt-4" column>
			<v-flex xs8>
				<v-autocomplete
					ref="autocomplete"
					v-model="selectedBuilding"
					v-on:click="selectedBuilding = null"
					@keyup.enter="directEnter"
					@change="closeKeyboard"
					hide-no-data
					auto-select-first
					autocomplete
					solo
					flat
					style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
					:items="buildingItems"
					:filter="customFilter"
					label="Building Name / Number / Addr"
					single-line
					:menu-props="{ maxHeight: 200 }"
					>
					<template
						slot="selection"
						slot-scope="{ item, tile }"
					  >
						<v-layout v-if="selectedBuilding" v-on:click="selectedBuilding = null">
						<v-list-tile-avatar dark tile color="grey darken-3" style="color: white;">
							{{item.bldgAlpha}}
						</v-list-tile-avatar>
						<v-list-tile-content>
						  <v-list-tile-title>
							{{item.name}}
						  </v-list-tile-title>
						  <v-list-tile-sub-title v-text="item.address"></v-list-tile-sub-title>
						</v-list-tile-content>
						</v-layout>
					  </template>
					<template
						slot="item"
						slot-scope="{ item, tile }"
					  >
						<v-list-tile-avatar dark tile color="grey darken-3" style="color: white;">
							{{item.bldgAlpha}}
						</v-list-tile-avatar>
						<v-list-tile-content>
						  <v-list-tile-title>
							{{item.name}}
						  </v-list-tile-title>
						  <v-list-tile-sub-title v-text="item.address"></v-list-tile-sub-title>
						</v-list-tile-content>
					  </template>
				</v-autocomplete>
			</v-flex>

			<v-flex xs1> 
				<v-autocomplete
					ref="roomselect"
					v-model="selectedRoom"
					autocomplete
					auto-select-first
					clearable
					solo
					flat
					:items="roomItems"
					label="Room"
					single-line
				></v-autocomplete>
			</v-flex>
			
			</v-layout>
		</v-layout>

	</v-toolbar> 
-->
</template>

<script>
import { mapState } from 'vuex'
import { mapMutations, mapActions } from 'vuex'
import Vuex from 'vuex'
import router from '../router'
import TestButton from './TestButton'

export default {  
  name: 'TopBannerPhone',

  data () {
	return {
	  bldgAutoSelect: null,
	  toolbarHeight: 70,
	}
  },

  components : { TestButton },

  watch: { //Reset Expansion Panels on building going null
		    '$store.state.space.selectedBuilding': function (newval) {
		    	if (!newval) {
		    		console.log("went null")
		    		this.updatePhoneSearch([])
		    	}
		    },

		    '$store.state.mapFunctions.mapReady': function () {
		    	this.updatePhoneSearch(0)
		    }
	  	},

  computed: {
	...mapState({   adminSidebarOpen : state => state.ui.adminSidebarOpen, 
					isSuperUser: state => state.user.isSuperUser,
					darkTheme: state => state.ui.darkTheme,
					mainSidebarOpen: state => state.ui.mainSidebarOpen,
				}),

	buildingItems : function () {
	  const items = []
	  this.$store.state.space.buildings.forEach(bldg => {
		bldg.text = `${bldg.bldgAlpha} - ${bldg.name}`
		bldg.value = bldg.bldgAlpha
		items.push(bldg)
	  })
	  return items
	},

    phoneSearchOpen: {
        get () {
          return this.$store.state.ui.phoneSearchOpen
        },
        set (value) {
            this.updatePhoneSearch(this.$store.state.ui.phoneSearchOpen ? null : 0)
        }
    },

	roomItems : function () {
	  return this.$store.state.space.buildingRooms.map((room) => {return room.number})

	},
	elevatorItems: function () {
		return [ 	{ text : 'Floor B', value: 'B' },
					{ text : 'Floor 1', value: '1' },
					{ text : 'Floor 2', value: '2' },
					{ text : 'Floor 3', value: '3' },
					{ text : 'Floor 4', value: '4' },
					{ text : 'Floor 5', value: '5' },
					{ text : 'Floor 6', value: '6' },
					{ text : 'Floor 7', value: '7' },
					{ text : 'Floor 8', value: '8' },
					{ text : 'Floor 9', value: '9' },
					{ text : 'Floor 10', value: '10' },
					{ text : 'Floor 11', value: '11' },
					{ text : 'Floor 12', value: '12' },
				]
	},
	selectedBuilding : {
		get () {
			return this.$store.state.space.selectedBuilding ? this.$store.state.space.selectedBuilding.bldgAlpha : null
		},

		set (value) {	
			//this.$refs.roomselect.focus()	    	
			this.updateSelectionCentering(true)
			this.selectBuilding(value).then(() => {
				if (value) {
					this.setCurrentFloor("1")
					// Select floor 1 if it exists, else select first valid floor
					this.setCurrentFloor((this.$store.state.space.selectedBuilding.floors.indexOf("1") === -1) ? this.$store.state.space.selectedBuilding.floors[0] : "1")
				}
			})
			
		}
	},

	currentFloor : {
		get() { return this.$store.state.ui.currentFloor },
		set (value) {
			this.setCurrentFloor(value)
		}
	},

	selectedRoom : {
		get () {
			return this.$store.state.space.selectedRoom ? this.$store.state.space.selectedRoom.number : null
		},
		set (value) {
			this.updateSelectionCentering(true)
			this.fetchFullRoom({bldgAlpha: this.selectedBuilding, number: value})
			
			if (this.$router.history.current.name === 'roomtableBldg') {
			this.$router.push({ name: 'roomtableBldg', params: { bldg: value }})
		}
		}
	},
  },

  methods: {
	...mapMutations(['updateMainSidebar',
					 'updateSelectionCentering',
					 'setSelectedRoom', 
					 'setSelectedBuilding',
					 'setCurrentFloor',
					 'updateContentSidebar',
					 'updateSearchResultSidebar',
					 'updateAdminSidebar',
					 'updateOptionsSidebar',
					 'updatePhoneSearch',
					]),
	...mapActions(['selectBuilding', 'fetchFullRoom']),

	customFilter (item, queryText, itemText) {
		//return JSON.stringify(item).toLowerCase().indexOf(queryText.toLowerCase()) > -1 
		
		const bldgAlpha = item.bldgAlpha.toLowerCase()
		const searchBlob = 	item.bldgAlpha + item.name + item.address + item.city + item.state + item.abbrev + 
							item.commonName + item.shortName + item.aliasName

		// If Search is 3 or less, use only the bldgAlpha.  Otherwise search the blob.
		if (queryText.length > 3 ) {
			return searchBlob.toLowerCase().indexOf(queryText.toLowerCase()) > -1
		} else {
			return bldgAlpha.indexOf(queryText.toLowerCase()) > -1 
		}
	},

	roomSelectEvent: function () {
		this.closeKeyboard()
		this.updatePhoneSearch(null)

	},

	toggleToolbar: function () {
		if (this.toolbarHeight == 70) {
			this.toolbarHeight = 206	// was 262 with Floor control
		} else {
			this.toolbarHeight = 70
		}
	},

	closeKeyboard () {
	  this.$refs.autocomplete.blur()
	  this.$refs.roomselect.blur()
	}

  }
}

</script>

<style>
.phoneTopMenu {
	z-index: 1 ;
}

.topToolBar {
	z-index: 100 !important;
}


.topTitlePhone {
	font-family: 'Open Sans', sans-serif;
	font-size: 20px;
	position:relative; top: -2px;
}

.blockaPhone {
  height: 45px;
  margin-right: 0px;
  margin-left: 0px;
  float: left;
}

.v-menu__content {
	z-index: 1000 !important;
}

.collapseButton {
	position: relative; 
	top: 25px; 
	z-index:1; 
}

.collapseIcon {

	border-style: solid;
	border-radius: 20px;
	border-width: 1px;
	border-color: #00000055;
	background-color: white;
}


/*To prevent copy-paste popup on mobile*/
/**
{
-webkit-user-select: none;
-khtml-user-select: none;
-moz-user-select: none;
-ms-user-select: none;
user-select: none;
}

input
{
-webkit-user-select: auto !important;
-khtml-user-select: auto !important;
-moz-user-select: auto !important;
-ms-user-select: auto !important;
user-select: auto !important;
}*/




</style>



// WEBPACK FOOTER //
// src/components/TopBannerPhone.vue